import React, { FC } from 'react';
import { TeachingLevelInput } from 'components/teaching-inputs';
import {
  RequestTutoringFields,
  useCurrentFormValues,
} from 'src/pages-all/details/tutor/components/RequestTutoringModal/request-tutoring-form.logic';
import { NextStepButton, RequestStepContainer } from '../components';
import styled from 'styled-components';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { useCurrentOffer } from 'logic/hooks/useCurrentOffer';
import { Text } from 'components/text/Text';

const TeachingLevelWrapper = styled.div`
  width: 50%;
`;

export const LevelStep: FC = () => {
  const { offer } = useCurrentOffer();
  const firstName = offer?.user?.firstName;
  const { requestTeachingLevel } = useCurrentFormValues();
  const buttonDisabled = !requestTeachingLevel;

  return (
    <RequestStepContainer
      title={translate(translationKeys.requestTutoringFlow.privateRequest, { firstName })}
    >
      <Text size={16}>{translate(translationKeys.requestTutoringFlow.whatLevel)}</Text>
      <TeachingLevelWrapper>
        <TeachingLevelInput
          showLabel={false}
          fieldName={RequestTutoringFields.Level}
          levelsVariant={'requestTeachingLevel'}
          label={translate(translationKeys.publishOffer.level.label)}
        />
      </TeachingLevelWrapper>
      <NextStepButton disabled={buttonDisabled} />
    </RequestStepContainer>
  );
};
